module.exports = __webpack_public_path__ + "static/media/site-logo.7d214e87.png";